/**
 * Componente para configurar reprodução de áudio
 * VigosCloud - Incoming Call System
 * 
 * Reutilizável para configurar áudio em qualquer etapa do fluxo de chamada
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faVolumeUp, 
  faInfoCircle,
  faPlay,
  faStop
} from '@fortawesome/free-solid-svg-icons';

import AudioSelectorUploads from '../../Audio/AudioSelectorUploads';

function AudioConfiguration({ 
  config = {
    audio_enabled: false,
    audio_file: '',
    audio_type: 'ura',
    audio_accountcode: '',
    hangup_after_audio: false
  },
  onChange,
  tenant,
  disabled = false,
  showHangupOption = true,
  title = 'Reprodução de Áudio'
}) {

  const handleChange = (field, value) => {
    if (onChange) {
      onChange({
        ...config,
        [field]: value
      });
    }
  };

  const handleAudioSelect = (fileName, fileType, accountCode) => {
    if (onChange) {
      onChange({
        ...config,
        audio_file: fileName,
        audio_type: fileType,
        audio_accountcode: accountCode
      });
    }
  };

  return (
    <div className="box" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <h3 className="title is-5 mb-4">
        <FontAwesomeIcon icon={faVolumeUp} className="mr-2" />
        {title}
      </h3>

      <div className="field">
        <label className="checkbox">
          <input
            type="checkbox"
            checked={config.audio_enabled || false}
            onChange={(e) => handleChange('audio_enabled', e.target.checked)}
            disabled={disabled}
          />
          <span className="ml-2">
            <FontAwesomeIcon icon={faVolumeUp} className="mr-2" />
            Reproduzir áudio
          </span>
        </label>
        <p className="help">
          Se habilitado, um áudio será reproduzido quando esta etapa for alcançada
        </p>
      </div>

      {config.audio_enabled && (
        <div>
          <div className="notification is-info is-light mb-3">
            <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
            Selecione um arquivo de áudio que será reproduzido. Os arquivos devem estar no formato WAV, MP3 ou GSM.
          </div>

          <div className="field">
            <label className="label">Selecionar Arquivo de Áudio *</label>
            <AudioSelectorUploads
              selectedFile={config.audio_file || ''}
              selectedType={config.audio_type || 'ura'}
              accountCode={tenant}
              onSelect={handleAudioSelect}
              disabled={disabled}
            />
          </div>

          {config.audio_file && (
            <div className="notification is-success is-light mt-3">
              <div className="level">
                <div className="level-left">
                  <div className="level-item">
                    <FontAwesomeIcon icon={faPlay} className="mr-2" />
                    <strong>Arquivo selecionado:</strong>
                    <span className="ml-2">{config.audio_file}</span>
                  </div>
                </div>
                <div className="level-right">
                  <div className="level-item">
                    <span className="tag is-success">
                      Tipo: {config.audio_type?.toUpperCase()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showHangupOption && (
            <div className="field mt-4">
              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={config.hangup_after_audio || false}
                  onChange={(e) => handleChange('hangup_after_audio', e.target.checked)}
                  disabled={disabled}
                />
                <span className="ml-2">
                  <FontAwesomeIcon icon={faStop} className="mr-2" />
                  Desligar chamada após reproduzir áudio
                </span>
              </label>
              <p className="help">
                Se marcado, a chamada será desligada imediatamente após a reprodução do áudio. 
                Útil para mensagens informativas (ex: "Escritório fechado").
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AudioConfiguration;

